export default {
  chooseFile: "Choose a file",
  browse: "Browse",
  clearFile: "Delete file",
  color: {
    hexValue: "Hexadecimal colour value",
    presets: "Preset colours",
    noColor: "No colour selected",
    picker: "Colour picker",
    open: "Open colour picker",
    saturation: "Saturation and brightness",
    saturationValue: "Saturation {saturation}%, brightness {value}%",
    hue: "Hue",
    red: "Red (0 to 255)",
    green: "Green (0 to 255)",
    blue: "Blue (0 to 255)",
  },
  icon: {
    list: "Icon list",
    selected: "Selected icon",
    invalid: "Please select a valid FontAwesome icon (light)",
    library: "Find the FontAwesome icon library",
  },
  empty_icon: "Enter an icon name (e.g. check)",
  info: "Information",
  requiredField: "This field is required",
  at_least_one_field_required: "You must select at least one option in this row.",
  requiredNumberOrFloat: "Please enter a whole or decimal number",
  emailError: "Please enter a valid e-mail address",
  phoneError: "Please enter a valid phone number",
  lastName: "Surname",
  firstName: "First name",
  email: "E-mail",
  address: "Address",
  complement: "Extra line",
  postCode: "Postcode",
  city: "Town/city",
  phone: "Tel.",
  mobile: "Mobile",
  function: "Function",
  actions: "Actions",
  rights: "Rights",
  send: "Send",
  errors: "Errors requiring attention",
  form_validation: "The following fields are required:",
  entitled: "Title",
  title: "Title",
  selectValue: "Select a value",
  uploaded_on: "Uploaded on",
  error_file: "This file does not seem to be available",
  no_skill_error_file: "This skill import is empty",
  download_success: "File downloaded successfully!",
  file_downloading: "Downloading in progress...",
  download_file: "Download file",
  remove_file: "Remove file",
  signed_error: "Error when saving",
  signed_success: "Changes have been saved successfully",
  saving: "Saving...",
  confirm: "Confirm",
  apply: "Apply",
  generate: "Generate",
  import: "Import",
  error_nofile: "Please add a file",
  error_file_format: "Please add a file in the correct format!",
  error_date: "The start date must fall before the end date",
  link: "Open link",
  dateChoice: "Click to choose a date",
  next: "Next",
  formTabPrevious: "Previous",
  formTabNext: "Next",
  pleaseWait: "Please wait...",
  select: "Select",
  cancel: "Cancel",
  save: "Save",
  leave_without_save: "Leave without save",
  leave_confirmation: "Are you sure you want to close without saving?",
  ok: "OK",
  edit: "Change",
  synchronize: "Synchronize",
  no: "No",
  yes: "Yes",
  warning: "Please note",
  iConfirm: "Confirm",
  Save: "Save",
  saveFinish: "Saved",
  fileFormatError: "Please select a file in the correct format",
  display: "Display",
  elements: "elements",
  lines: "Lines",
  conditions: {
    title: "Template application condition",
    info: "To create specific templates, please duplicate the default template and define the application conditions (tab 3)",
    alerte:
      "By default, this template applies to all cases. If you set conditions below, the template will only apply when all conditions are met (AND logic).",
  },
  pagination: {
    to: "to",
    on: "on",
  },
  close: "Close",
  overview: "Preview",
  regenerate: "Regenerate",
  option_value: "Value",
  option_label: "Label",
  submit: "Send",
  submit_success: "Form submitted successfully!",
  back: "Back",
  remove: "Remove",
  typeYourSearch: "Type in a search term",
  sortBy: "Sort by",
  order: "Order",
  desc: "Decreasing",
  asc: "Increasing",
  reset: "Reset",
  filter: "Filter",
  Search: "Search",
  "No data available in the table": "No data available in the table",
  "No data available": "No data available",
  "Please enter or modify your search": "Please enter or edit your search",
  "Please click on the add button": "Please click on the button to add more",
  search: "Search",
  All: "All",
  None: "N/A",
  choicesScrollLabel: "List of choices, scrollable",
  "PDF export": "PDF export",
  "Excel export": "Excel export",
  "PNG export": "PNG export",
  "SVG export": "SVG export",
  "See statistics": "View statistics",
  multiselect: {
    press_enter: "",
    press_enter_group: "",
    selected: "",
    press_enter_remove: "",
    press_enter_remove_group: "",
    press_enter_create_tag: "Add a value",
    select_option: "",
    no_result: "No results match your search",
    no_options: "Type at least {nb} characters to search results...",
  },
  init_search: "Reset search",
  search_motor: "Search engine",
  file_size_error: "The file is too large, please select one smaller than ",
  video_not_supported_mobile: "Adding a video is not available from the mobile app",
  maxTagError: "Please make sure you do not enter more than the maximum value",
  minTagError: "Please make sure you do not enter less than the minimum value",
  see_more_fields: "View more fields",
  justificative_piece: "Supporting documents",
  skillRecap: "Skills assessment",
  valid: "Validate",
  unlock: "Unlock",
  light: "Light",
  dark: "Dark",
  system: "System",
  extensions_accepted:
    "Please select a file in one of the following formats: pdf, doc, xls, xlsx, csv, docx, jpeg, svg, bmp, gif or png.",
  extensions_accepted_document_image:
    "Please select a file in one of the following formats: pdf, doc, docx, xls, xlsx, pptx, gif, jpeg or png.",
  tab_error: "Error on this tab",
  tab_status_pending: "Tab pending",
  tab_status_in_progress: "Tab in progress",
  tab_status_completed: "Tab completed",
  regenerate_succes: "ID successfully regenerated!",
  password_validation: {
    title: "Please enter a password that includes:",
    condition1: "A capital letter",
    condition2: "A tiny letter",
    condition3: "A figure",
    condition4: "A special character",
    condition5: "Minimum 12 characters",
  },
  dropzone: {
    release: "Drop the files here to upload it.",
    drop: "Upload the files here or",
    click_here: "click",
    to_upload: "to upload.",
    downloading: "Downloading...",
    file: "File",
    max_files: "Maximum {count} files",
    max_files_message: "You have already reached the file limit.",
    max_file_size: "The file size {name} exceeds the permitted limit.",
    file_extension_error: "The file extension {name} is invalid.",
    error_title: "Please note that some files have not been accepted.",
    file_size_error: "The maximum size per file is {size} MB.",
    upload_timeout_error: "The file upload took too long and was interrupted. Please try again.",
  },
  upload_signed_document: {
    label: "Upload the signed document",
    one_file: "You must upload at least 1 file",
    file_only: "Please select a PDF file",
    overview: "Preview",
    close: "Close",
    regenerate: "Regenerate",
    option_value: "Value",
    option_label: "Label",
  },
  user_permissions: {
    archive_label: "View archived promotions",
    profile_label: "View all active profiles",
    search_label: "Search...",
    title: "List of user profiles",
    choose_profile: "Select the profile you wish to add",
  },
  form_error: {
    verify_fields: "Some fields in the form contain errors; please check them and resubmit the form",
    minimum_value: "Minimum value: {value}",
    maximum_value: "Maximum value: {value}",
  },
  editor: {
    image_upload_error: "Error uploading image",
    image_read_error: "Error reading image",
    file_upload_error: "Error uploading the file",
    file_read_error: "Error reading the file",
    insert_image: "Insert image",
    image_size_title: "Image size",
    image_alt: "Alternative text",
    image_width: "Width",
    image_height: "Height",
  },
  filePicker: {
    camera: "Camera",
    files: "Files",
    pictures: "Pictures",
    clipboard_no_image: "Clipboard does not contain an image",
    clipboard_unavailable: "Cannot access clipboard",
    permission_denied_camera: "Camera access is denied. Please enable it in your device settings.",
    permission_denied_photos: "Photo library access is denied. Please enable it in your device settings.",
    error: "An error occurred while retrieving the file",
  },
  slider: {
    start: "Start",
    in_progress: "In progress",
    end: "Finished",
  },
  writing_assistant: {
    title: "Writing assistant",
    disable: "Disable the assistant",
    toggle_label: "AI assistant",
    helpful: "This question helped me",
    dismiss: "Hide this question",
    loading: "Generating questions…",
    unavailable: "The assistant is temporarily unavailable",
    questions_announce: "{count} question from the assistant | {count} questions from the assistant",
    minutes: "{count} minute | {count} minutes",
    minutes_short: "{count} min",
    paused: "Paused on {field} · back in {duration}",
    paused_many: "Paused on {count} fields · next back in {duration}",
    paused_announce: "The assistant is paused on {fields}; back in {duration}.",
    resumed_announce: "The assistant is available again on {fields}.",
    field_quoted: "“{field}”",
    fields: {
      contexte: "Context",
      taches: "Tasks",
      difficultes: "Difficulties",
      resultats: "Results",
      apprentissages: "Learning",
      unknown: "this field",
    },
    info: {
      aria_label: "How does the AI assistant work?",
      title: "How does it work?",
      purpose: "The assistant asks you questions to help you flesh out your text.",
      triggers: "It starts on its own when your text reaches {threshold} characters, after a short typing pause.",
      limit:
        "Up to {max} suggestions per field. Once they are used up, the assistant becomes available again on that field after {duration}.",
    },
  },
  date_error: {
    date_format_error: "Invalid date format",
    date_min_error: "The date must be strictly after the field {fieldName}",
    date_max_error: "The date must be strictly before the field {fieldName}",
  },
  number_error: {
    number_format_error: "Invalid number format",
    number_min_error: "This field must be less than or equal to the field {fieldName}",
    number_max_error: "This field must be greater than or equal to the field {fieldName}",
  },
};
